import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29211290")

_pushScopeId("data-v-29211290")
const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "progresoSolicitud" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "etiquetaPasoSolicitud"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("small", { class: "etiquetaPasoSolicitud" }, "En verificación", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("small", { class: "etiquetaPasoSolicitud" }, "En autorización", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("small", { class: "etiquetaPasoSolicitud" }, "Planeación financiera", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("small", { class: "etiquetaPasoSolicitud" }, "Mesa de Control", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("small", { class: "etiquetaPasoSolicitud" }, "En Cuentas por pagar", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("small", { class: "etiquetaPasoSolicitud" }, "En proceso de pago", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("svg", { class: "iconoPunto" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#checkmark-bold" })
], -1)
const _hoisted_18 = {
  key: 0,
  class: "etiquetaPasoSolicitud"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("ol", _hoisted_2, [
        _createVNode("li", {
          class: ["pasoSolicitud", _ctx.Estado.enCreacion]
        }, [
          _hoisted_3,
          _createVNode("small", {
            class: "etiquetaPasoSolicitud",
            hidden: _ctx.labelEnCreacion
          }, "En creación", 8, ["hidden"]),
          (_ctx.estatusRequisicionId == 'EN_ACLARACION')
            ? (_openBlock(), _createBlock("small", _hoisted_4, "En aclaración"))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.tieneVerificador)
          ? (_openBlock(), _createBlock("li", {
              key: 0,
              class: ["pasoSolicitud", _ctx.Estado.enVerificacion]
            }, [
              _hoisted_5,
              _hoisted_6
            ], 2))
          : _createCommentVNode("", true),
        _createVNode("li", {
          class: ["pasoSolicitud", _ctx.Estado.enAutorizacion]
        }, [
          _hoisted_7,
          _hoisted_8
        ], 2),
        _createVNode("li", {
          class: ["pasoSolicitud", _ctx.Estado.enPlaneacionFinanciera]
        }, [
          _hoisted_9,
          _hoisted_10
        ], 2),
        _createVNode("li", {
          class: ["pasoSolicitud", _ctx.Estado.enMesaControl]
        }, [
          _hoisted_11,
          _hoisted_12
        ], 2),
        _createVNode("li", {
          class: ["pasoSolicitud", _ctx.Estado.enCXP]
        }, [
          _hoisted_13,
          _hoisted_14
        ], 2),
        _createVNode("li", {
          class: ["pasoSolicitud", _ctx.Estado.enProcesoPago]
        }, [
          _hoisted_15,
          _hoisted_16
        ], 2),
        _createVNode("li", {
          class: ["pasoSolicitud", _ctx.Estado.pagoAplicado]
        }, [
          _hoisted_17,
          _createVNode("small", {
            class: "etiquetaPasoSolicitud",
            hidden: _ctx.labelPagoAplicado
          }, " Pago aplicado", 8, ["hidden"]),
          (_ctx.estatusRequisicionId == 'PAGO_RECHAZADO')
            ? (_openBlock(), _createBlock("small", _hoisted_18, " Pago aplicado"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
})